import { useHomeBanner } from '@/src/api/getData';
import Banner from '@/components/banner';



const SitemapView = ({ navigationData, language = '' }: { navigationData: any, language?: string }) => {
    const { data: banner } = useHomeBanner(language);
    let navData = navigationData?.item || [];

    console.log("Sitemap Info Data", navData);

    return (
        <main className='theme-normal format-normalEditor'>
            <Banner banner={banner} category="Sitemap" />
            <section className="sitemap container" id="start">
                <ul>
                    {navData?.map((item: any, index: number) => (
                        <li key={item.id || index} className={`${item.Display != true ? "hidden" : ""}`}>
                            <a href={`/${language}${item.Url ? item.Url : '/'}`}>{item.Title?item.Title:item.title}</a>

                            {item.subMenu && item.subMenu.length > 0 && (
                                <ul>
                                    {item.subMenu.map((subMenu: any, subIndex: number) => (
                                        <li key={subIndex} className={`${subMenu.Display != true ? "hidden" : ""}`}><a href={`/${language}${subMenu.url ? subMenu.url : '/'}`}>{subMenu.title}</a>
                                            {subMenu.Tier3 && subMenu.Tier3.length > 0 && (
                                                <ul className={subMenu.Display != true ? "hidden" : ""}>
                                                    {subMenu.Tier3.map((tier3Item: any, tier3Index: number) => (
                                                        <li key={tier3Index} className={`tier3-item ${tier3Item.Display != true ? "hidden" : ""}`}>
                                                            <a href={(tier3Item.Url ? `/${language}${tier3Item.Url}` : '/')}>{tier3Item.Title}</a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            </section>
        </main>
    );
}

export default SitemapView;
